import React from 'react';
import Card from '../../Shared/Cards/FeatureCard/Card';
import { security } from './data';
import './Styles/Security.scss';
import {HiArrowNarrowRight} from 'react-icons/hi';
const Security=()=>{
    return(
        <div className="enterprise-security">
         <div className="content">
      <h1>Your security and compliance needs covered</h1>
      <p>Hostdesign Enterprise provides above industry standard security to protect your work and data. We are EU hosted, GDPR compliant and provide enhanced protection features such as Single Sign-On and access locks to secure projects. </p>
      <span>Read more about security <HiArrowNarrowRight className="icon" /></span>
         </div>
         <div className="cards">
         {security.map((d) =>{
                return(
                    <Card  {...d}/>
                )
            })}
         </div>
        </div>
    )
};
export default Security;